import React, { Fragment } from "react";
import Field from "../../components/Field";
import CheckboxField from "../../components/CheckboxField";

const Kjorstjori = props => {
  const { formState, timestamp } = props;
  
  return (
    <Fragment>
      <h2>Vottorð kjörstjóra</h2>
      <p style={{ fontWeight: "bold", marginBottom: 25 }}>Það vottast hér með að ofangreindur kjósandi hefur greitt atkvæði:</p>
      
      <div style={{ gap: 30, display: "flex", marginBottom: 30 }}>
        <Field label="Staður" style={{ flex: 3 }} id="stad-kjst-f" />
        <Field label="Dagsetning" style={{flex: 2 }} id="dags-kjst-f" value={timestamp} />
      </div>
      <div style={{ gap: 30, display: "flex", marginBottom: 30 }}>
        <Field label="Undirritun kjörstjóra" style={{ flex: 3, marginTop: 10 }} id="undr-kjs-f" />
        <div style={{ display: "flex", flex: 2, flexDirection: "column", height: 120 }}>
          <h3>Embættisstimpill</h3>
        </div>
      </div>
      <div style={{ display: "flex", gap: 50 }}>
        <div style={{ flex: 50 }}>
          <h3 style={{ textTransform: "uppercase" }}>
            Kjósandi á rétt á aðstoð við atkvæðagreiðsluna
          </h3>
          <p>
            Aðstoð skal veitt af kjörstjóra eða aðstoðarmanni sem fylgir
            kjósanda á kjörstað. Aðstoð skal því aðeins veita að kjósandi
            geti sjálfur skýrt þeim er aðstoðina veitir frá því hvernig hann
            vill greiða atkvæði.
          </p>
        </div>
        <div style={{ flex: 38 }}>
          <h3 style={{ textTransform: "uppercase" }}>
            Útfyllist ef kjósandi fær aðstoð
          </h3>
          <div>
            <span style={{ display: "block", marginBottom: 10 }}>Aðstoð veitt af:</span>
            <div style={{ display: "flex", gap: 50 }}>
              <CheckboxField id="adst-kjst" label="Kjörstjóra" isChecked={formState.adstodKjorstjori} />
              <CheckboxField id="adst-kjst" label="Aðstoðarmanni kjósanda" isChecked={formState.adstodFulltrui} />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Kjorstjori;
